/* eslint-disable jsx-a11y/alt-text */
import { Container } from '@/components/shared/Container'
import React from 'react'
import styled from 'styled-components'
import { Image } from 'react-datocms'
import Link from 'next/link'

const StyledReviewer = styled.div`
  p {
    line-height: 28px;
    color: ${(props) => props.theme.v2.text.secondary};
    &.meta {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin: 0;
    }
  }
  h4 {
    color: ${(props) => props.theme.v2.onSurface.text};
    font-weight: 400;
    margin-bottom: 8px;
  }
  img {
    border-radius: 16px;
    margin-bottom: 24px;
    object-fit: cover;
  }
`

const StyledReviewers = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 24px 24px;
  margin-bottom: 48px;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`

const ReviewerProfile = ({ reviewer }) => {
  return (
    <StyledReviewer>
      <Link href={`/learn/${reviewer.slug}`} passHref>
        <Image data={reviewer.authorImage.responsiveImage} />
        <h4>
          {reviewer.name}
          {reviewer.qualifications && <>, {reviewer.qualifications}</>}
        </h4>
        {reviewer.jobTitle && <p className="meta">{reviewer.jobTitle}</p>}
        {reviewer.institution && <p className="meta">{reviewer.institution}</p>}
        <p className="small secondary">{reviewer.briefBio}</p>
      </Link>
    </StyledReviewer>
  )
}

export const ReviewersProfiles = ({ reviewers }) => {
  const reviewerElements = reviewers.map((r) => <ReviewerProfile key={r.slug} reviewer={r} />)

  return (
    <Container>
      <StyledReviewers>{reviewerElements}</StyledReviewers>
    </Container>
  )
}
